import { t } from 'i18next'
import { debounce } from 'lodash'

import BadgeIsValid from '~/components/BadgeIsValid'
import Panel from '~/components/Panel'
import { FormGroup, InputMoney } from '~/components/unform'
import { formatMoneyV2 } from '~/helpers'
import { useAppInfo } from '~/hooks/useAppInfo'

import { debounceDelay } from '../../../../hooks/constants'
import { useRechargeForm } from '../../../../hooks/useRechargeForm'

const AmountSection = () => {
  const { currencyUseCents, rechargeMinValue } = useAppInfo()

  const { amountStepIsValid, handleChangeAmount } = useRechargeForm()

  const handleChange = debounce((data: { floatValue: number }) => {
    const valueDailyBudget = data.floatValue
    const amount = currencyUseCents
      ? Number(valueDailyBudget) / 100
      : Number(valueDailyBudget)

    handleChangeAmount({
      amount,
      isValid: amount >= rechargeMinValue
    })
  }, debounceDelay)

  const formattedRechargeMinValue = formatMoneyV2({ value: rechargeMinValue })

  return (
    <Panel
      title={t('rm:Value')}
      description={t('rm:value.set')}
      iconLeft={<BadgeIsValid isValid={amountStepIsValid} />}
    >
      <FormGroup className="w-25">
        <InputMoney
          id="amount"
          name="amount"
          placeholder={formattedRechargeMinValue}
          onChange={handleChange}
          helpText={t('rm:minimumValueOf', {
            value: formattedRechargeMinValue
          })}
        />
      </FormGroup>
    </Panel>
  )
}

export default AmountSection
